import { computed, ComputedRef } from 'vue';
import { useRouter } from 'vue-router/composables';
import i18n from '../../../shared/locales/i18n';
import { portalRoles } from '../../../shared/enums/portalRoles';
import { parentTypes } from '../../../shared/enums/parentTypes';
import { textUtil } from '../../../shared/utils/textUtil';
import { SearchInstitutionProfileResult } from '../../../shared/models/responses/search/findGeneric.response';

export const useSearchResultProfile = (
  getResult: () => SearchInstitutionProfileResult,
  getSearchString: () => string
): {
  roleLabel: ComputedRef<string>;
  institutionName: ComputedRef<string>;
  searchQueries: ComputedRef<RegExp[] | string>;
  openProfile: () => void;
} => {
  const t = i18n.t.bind(i18n);
  const router = useRouter();

  const roleLabel = computed(() => {
    switch (getResult()?.portalRole) {
      case portalRoles.CHILD:
        return t('user.role_child');
      case portalRoles.GUARDIAN:
        return t('user.role_guardian');
      case portalRoles.EMPLOYEE:
        return t('user.role_employee');
      default:
        return '';
    }
  });

  const institutionName = computed(() => getResult()?.institutionName ?? '');

  const searchQueries = computed<RegExp[] | string>(() => {
    const searchString = getSearchString();
    if (!searchString) {
      return '';
    }
    return [textUtil.buildHighlightRegex(searchString)];
  });

  const openProfile = (): void => {
    if (!router) {
      return;
    }
    router.push({
      name: 'userview',
      params: { id: getResult().id },
      query: { parent: parentTypes.SEARCH },
    });
  };

  return {
    roleLabel,
    institutionName,
    searchQueries,
    openProfile,
  };
};
